import * as React from 'react';
import { cn } from '@/lib/cn';

type LabelProps = React.LabelHTMLAttributes<HTMLLabelElement> & { ref?: React.Ref<HTMLLabelElement> };

export const Label = ({ ref, className, htmlFor, children, ...props }: LabelProps) => {
  return (
    <label
      ref={ref}
      htmlFor={htmlFor}
      className={cn('text-xs font-medium text-text-secondary tracking-wide', className)}
      {...props}
    >
      {children}
    </label>
  );
};
Label.displayName = 'Label';
